import {decodeHTMLEntities} from '@pinecast/gql/decodeHTMLEntities';

export default function () {
  return JSON.parse(
    document.getElementById('preloaded-queries')!.innerHTML,
    (_, value) =>
      typeof value === 'string' ? decodeHTMLEntities(value) : value,
  );
}
